var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.49996C2.5 6.6159 2.85119 5.76806 3.47631 5.14294C4.10143 4.51782 4.94928 4.16663 5.83333 4.16663H14.1667C15.0507 4.16663 15.8986 4.51782 16.5237 5.14294C17.1488 5.76806 17.5 6.6159 17.5 7.49996V12.5C17.5 13.384 17.1488 14.2319 16.5237 14.857C15.8986 15.4821 15.0507 15.8333 14.1667 15.8333H5.83333C4.94928 15.8333 4.10143 15.4821 3.47631 14.857C2.85119 14.2319 2.5 13.384 2.5 12.5V7.49996Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 7.49996L12.5 9.99996L8.33333 12.5V7.49996Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.7d06aa6160f4667b30c5cc79edeee417.svg";
export { ForwardRef as ReactComponent };